import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpsertFeatureFlagBody } from '../schemas';
import type { IUpsertFeatureFlagResponse } from './upsert-feature-flag-response';
import { upsertFeatureFlagResponseSchema } from './upsert-feature-flag-response';

interface IUpsertFeatureFlagRequest {
  key: string;
  body: IUpsertFeatureFlagBody;
}

export async function upsertFeatureFlagApi({
  key,
  body,
}: IUpsertFeatureFlagRequest): Promise<IValidatedResponse<IUpsertFeatureFlagResponse>> {
  return putRequest<IUpsertFeatureFlagResponse>({
    path: `/sys/feature-flags/${key}`,
    body,
    schema: upsertFeatureFlagResponseSchema,
  });
}
